<template>
  <el-dialog v-model="payMoneyShow" title="媒体付款申请" width="500px" :show-close="false" :close-on-click-modal="false">
    <el-form :model="form" label-width="120px">
      <el-form-item label="媒体产品" required>
        <el-select
          v-model="uploadSelectPro"
          filterable
          clearable
          placeholder="产品列表"
          @clear="handleClear"
          @change="handleProSelect"
        >
          <el-option
            v-for="item in proList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="付款主体">
        <el-input v-model="form.entity" placeholder="付款主体"/>
      </el-form-item>
      <el-form-item label="开户行">
        <el-input v-model="form.bank" placeholder="开户行"/>
      </el-form-item>
      <el-form-item label="付款账号">
        <el-input v-model="form.bankAccount" placeholder="付款账号"/>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="saveSubmit">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, reactive, ref, watch } from 'vue'
import utils from '@/utils/utils'
import { payMoney } from '@/api/media'
import { ourCompanySelect } from '@/views/invoice/common'
import { addMediaBank } from '@/api/pay-info'

const props = defineProps({
  modelValue: {
    type: Boolean,
    require: true,
    default: false
  },
  productList: {
    type: Object,
    required: true
  }
})

const form = reactive({
  proId: -1,
  entity: '',
  bank: '',
  bankAccount: ''
})
const uploadSelectPro = ref('')
const totalProList = ref([])
const proList = ref([])
const payMoneyShow = ref(props.modelValue)
const emits = defineEmits(['update:modelValue', 'refreshDataList'])

const handleProSelect = async (value) => {
  form.proId = value
}

watch(() => props.productList, (value, o) => {
  totalProList.value = value
  proList.value = filterProList(value)
})

watch(() => props.modelValue, (value, o) => {
  payMoneyShow.value = value
  if (value) {

  }
})

const filterProList = (data) => {
  return data.filter((item, index, self) => {
    return item.payMode === '1'
  }).map(item => {
    return {
      label: item.meidaType + '-' + item.proType + '-' + item.mediaPort,
      value: item.id
    }
  })
}

const saveSubmit = async () => {
  if (form.proId === -1 || form.entity === '' || form.bankAccount === '' || form.bank === '') {
    utils.showError('请输入正确信息')
    return
  }

  const result = await addMediaBank({
    belongProduct: form.proId,
    entity: form.entity,
    bank: form.bank,
    bankAccount: form.bankAccount
  })
  if (result) {
    payMoneyShow.value = false
    emits('update:modelValue', false)
    emits('refreshDataList')
  }
}

const close = () => {
  payMoneyShow.value = false
  emits('update:modelValue', false)
  emits('refreshDataList')
}
</script>
